import { FieldBase } from '@/components/form';
import { Toggle } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { TAGE } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { useTranslation } from 'react-i18next';

export function TageSelect() {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  const options = Object.entries(TAGE).map(([key, value]) => ({
    value,
    label: t(`general.date.days.${key}Short`),
  }));
  return (
    <div className="flex flex-col gap-4">
      <span className="text-neutrals-900 text-base font-bold leading-6">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.arbeitstage.description',
        )}
      </span>

      <form.AppField name="bezahlung.sollstunden.arbeitstage">
        {(field) => (
          <FieldBase>
            <div className="flex gap-2">
              {options.map((option) => (
                <Toggle
                  key={option.value}
                  value={option.value}
                  onPressedChange={(pressed) => {
                    const currentValue = field.state.value || [];
                    if (pressed) {
                      field.handleChange([...currentValue, option.value]);
                    } else {
                      field.handleChange(
                        currentValue.filter(
                          (value: number) => value !== Number(option.value),
                        ),
                      );
                    }
                  }}
                  pressed={field.state.value.includes(option.value)}
                  className="size-10 bg-neutrals-200 rounded-full data-[state=on]:bg-primary-blue-600 data-[state=on]:text-neutrals-100 text-sm font-normal">
                  {option.label}
                </Toggle>
              ))}
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
